import type { FC } from 'react';

import type { Need, NeedTone } from './inbound';

const TONES: Record<NeedTone, { bg: string; fg: string }> = {
    muted: { bg: 'rgb(241, 245, 249)', fg: 'rgb(100, 116, 139)' },
    info: { bg: 'rgb(224, 242, 254)', fg: 'rgb(3, 105, 161)' },
    warn: { bg: 'rgb(254, 243, 199)', fg: 'rgb(180, 83, 9)' },
    bad: { bg: 'rgb(254, 226, 226)', fg: 'rgb(185, 28, 28)' },
    good: { bg: 'rgb(220, 252, 231)', fg: 'rgb(22, 101, 52)' },
};

/**
 * One short chip saying what a row is waiting on. The chip IS the status for the inbound
 * flow: a person reads "Forwarder" or "Dispatch overdue 3d" and knows the next move without
 * decoding a state machine.
 */
export const NeedChip: FC<{ need: Need; onClick?: () => void }> = ({ need, onClick }) => {
    const tone = TONES[need.tone];
    return (
        <span
            title={need.title}
            onClick={onClick}
            // The same shape, size and letter-spacing as the status badge beside it, so a row
            // reads as one family of chips rather than two.
            style={{
                display: 'inline-block',
                padding: '2px 8px',
                borderRadius: 4,
                fontSize: 10,
                fontWeight: 600,
                letterSpacing: '0.05em',
                lineHeight: 1.5,
                whiteSpace: 'nowrap',
                background: tone.bg,
                color: tone.fg,
                cursor: onClick ? 'pointer' : 'default',
            }}
        >
            {need.label}
        </span>
    );
};

export const NeedChips: FC<{ needs: Need[]; onClick?: () => void }> = ({ needs, onClick }) => (
    <span style={{ display: 'inline-flex', gap: 4, flexWrap: 'wrap' }}>
        {needs.map((n) => (
            <NeedChip key={n.label} need={n} onClick={onClick} />
        ))}
    </span>
);
